<template>
	<div class="talent-pool-container">
		<div>
			<div v-if="loading" class="background">
				<div v-if="loading" class="text-center lds-circle">
					<div><img src="@/assets/img/logo.png" /></div>
				</div>
			</div>
		</div>
		<md-card v-if="!loading">
			<div class="container talentPool">
				<div class="talentPoolActions">
					<md-field style="max-width: 500px">
						<md-input type="search" class="mb-3" clearable placeholder="Search records" v-model="search"> </md-input>
					</md-field>
					<md-button @click="toggleFilterMenu" class="md-success btn-talent-pool" style="width: 150px"> Filter</md-button>
				</div>
				<div class="talentPoolActions">
					<p>{{ selected.length }} student(s) selected</p>
					<div v-if="errorMessage !== ''">
						<p v-if="!selected.length" style="color: red">{{ errorMessage }}</p>
					</div>

					<div class="talentPoolActions">
						<md-button v-if="selected.length" @click="clearSelectedList" class="md-danger btn-talent-pool" style="width: 10px; margin-right: 10px"> Clear</md-button>
						<md-button @click="inviteToInterview" class="jb-standard btn-talent-pool" style="width: 150px"> Invite to Apply</md-button>
					</div>
				</div>
				<md-table v-model="reactiveList" md-card @md-selected="onSelect" id="content">
					<md-table-toolbar>
						<h1 class="md-title">Students in {{ currentTalentPool.name }} Talent Pool</h1>
					</md-table-toolbar>

					<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="multiple">
						<md-table-cell md-label="Name" md-sort-by="name">{{ item.name }}</md-table-cell>
						<md-table-cell md-label="Surname" md-sort-by="surname">{{ item.surname }}</md-table-cell>
						<md-table-cell md-label="Career Track" md-sort-by="careerTrack">
							{{ item.careerTrack }}
						</md-table-cell>

						<md-table-cell md-label="Email" md-sort-by="email" style="max-width: 200px">{{ item.email }}</md-table-cell>
						<md-table-cell md-label="Status" md-sort-by="status" style="max-width: 60px">{{ item.status }}</md-table-cell>

						<md-table-cell style="max-width: 200px">
							<md-button @click="viewStudentinTalentPool(item)" class="md-success btn-talent-pool" style="width: 100px"> View Student</md-button>
						</md-table-cell>

						<md-table-cell style="max-width: 200px">
							<md-button @click="inviteStudent(item)" class="jb-standard btn-talent-pool" style="width: 120px">Invite to apply</md-button>
						</md-table-cell>
						<md-table-cell v-if="auth">
							<div @click="setFavourite(item)">
								<div v-if="item.isTalentPoolFavourite">
									<md-icon style="color: #e2c800">star</md-icon>
								</div>
								<div v-else>
									<md-icon>star_border</md-icon>
								</div>
							</div>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>
		</md-card>

		<modal v-if="profileModalVisible" @close="profileModalHide" size="xl">
			<template slot="header">
				<md-button class="md-simple md-just-icon md-round modal-default-button" @click="profileModalHide">
					<md-icon>clear</md-icon>
				</md-button>
			</template>

			<template slot="body">
				<div style="z-index: 999">
					<CandidateProfile
						:userProfile="currentProfile"
						@setProfileFavourite="setProfileFavourite"
						:showFavoriteButton="true"
						:isTalentPool="isTalentPool"
						:currentTalentPool="currentTalentPool"
						:showStatus="'talent pool'"
					/>
				</div>
			</template>
		</modal>

		<StudentFilter
			v-if="isFilterClicked"
			:isFilterClicked="isFilterClicked"
			@update:isClosed="handleFilterClose"
			@filterChanged="handleFilterChange"
			:uniqueInstitutions="uniqueInstitutions"
			:uniqueQualificationTypes="uniqueQualificationTypes"
			:uniqueYearOfStudy="uniqueYearOfStudy"
			:uniqueDegrees="uniqueDegrees"
			:uniqueInterestedDepartments="uniqueInterestedDepartments"
			:uniquePreferredEmployers="uniquePreferredEmployers"
			:uniqueProgrammes="uniqueProgrammes"
			:uniqueRaces="uniqueRaces"
			:uniqueGenders="uniqueGenders"
			:uniqueDriversLicense="uniqueDriversLicense"
			:uniqueVehicles="uniqueVehicles"
			:uniqueDisability="uniqueDisability"
			:uniqueCitizenships="uniqueCitizenships"
			:uniqueLocations="uniqueLocations"
			:students="currentTalentPoolStudentTalentPool || []"
			:uniqueCareerTracks="uniqueCareerTracks"
			:selectedCareerTracks.sync="selectedCareerTracks"
			@clearFilters="clearFilters"
		/>

		<div style="max-width: 250px">
			<modal v-if="openInviteModal">
				<template #body>
					<div style="margin: 10px">
						<div style="padding: 0px !important; margin: 0px !important">
							<h3 style="font-weight: bold">Invite to Apply</h3>
							<p style="margin-top: 10px">Invite ({{ selected.length }}) selected student(s) to apply for a job posting</p>
						</div>

						<div v-if="jobs.length !== 0" style="margin-bottom: 20px">
							<div>
								<p style="font-weight: bold">Select Job Posting</p>
								<p style="color: red">{{ jobErrorMessage }}</p>
								<md-field>
									<md-select v-model="selectedJob" placeholder="Select a job">
										<md-option v-for="job in jobs" :key="job.jobId" :value="job.name">{{ job.name }}</md-option>
									</md-select>
								</md-field>
							</div>
						</div>
						<div v-else-if="jobs.length === 0" style="margin-bottom: 20px">
							<p>Before you can invite someone to apply, please post a job</p>
							<md-button class="jb-standard" @click="redirectToJobPost">Post a job</md-button>
						</div>

						<p style="font-weight: bold">Selected Student(s) ({{ selected.length }})</p>
						<div style="max-height: 250px; overflow-y: auto; margin-bottom: 30px; border-radius: 5px">
							<md-list>
								<md-list-item v-for="(item, index) in selected" :key="item.userId">
									{{ `${selected[index].name} ${selected[index].surname} - ${selected[index].qualifications[0].degree}` }}
									<md-divider class="md-inset"></md-divider>
								</md-list-item>
							</md-list>
						</div>
					</div>
				</template>
				<template #footer>
					<div v-if="jobs.length !== 0">
						<md-button class="md-danger" style="margin-right: 1rem" @click="closeInvitationModal">Cancel</md-button>
						<md-button class="md-success" @click="sendJobInvitations">Send Invitations</md-button>
					</div>
					<div v-else>
						<md-button class="md-success" @click="openInviteModal = fasle">Ok</md-button>
					</div>
				</template>
			</modal>
		</div>

		<div v-if="emailSent">
			<modal>
				<template #header>
					<h3>Success! 🥳</h3>
				</template>

				<template #body>
					<div>
						<p>Email(s) have been successfully sent!</p>
					</div>
				</template>

				<template #footer>
					<md-button class="md-primary" @click="closeConfirmationModal()">Ok</md-button>
				</template>
			</modal>
		</div>

		<div v-if="errorAuth">
			<modal>
				<template #body>
					<div>
						<p>{{ authError }}</p>
					</div>
				</template>

				<template #footer>
					<div style="display: flex; flex-direction: row; justify-content: space-between">
						<md-button class="md-primary" style="color: white !important; margin-right: 20px" @click="promptLogin">Login</md-button>
						<md-button class="md-danger" style="color: white !important" @click="errorAuth = false">Cancel</md-button>
					</div>
				</template>
			</modal>
		</div>
	</div>
</template>

<script>
import { Modal } from '@/components';
import { useVuelidate } from '@vuelidate/core';
import { required, email } from '@vuelidate/validators';
import db from '@/firebase/init';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import CandidateProfile from '@/components/Profile/CandidateProfile.vue';
import StudentFilter from '@/components/Filters/StudentFilter.vue';
import { collection, query, where, getDocs, getDoc, doc, setDoc } from 'firebase/firestore';
import { ApplicationStatus } from '../../../../constants/application-status';

export default {
	name: 'TableTemplate',
	components: { Modal, CandidateProfile, StudentFilter },
	setup() {
		return { v$: useVuelidate() };
	},
	data: () => ({
		errorAuth: false,
		authError: '',
		emailSent: false,
		personalisedMessage: '',
		selectedJob: null,
		jobs: [],
		openInviteModal: false,
		jobErrorMessage: '',
		errorMessage: '',
		selected: [],
		isTalentPool: 'TalentPool',
		currentTalentPool: {},
		currentTalentPoolStudentTalentPool: [],
		profileModalVisible: false,
		userProfile: null,
		talentPools: [],
		loading: false,
		availableTalentPool: [],
		currentProfile: null,
		isFilterClicked: false,
		search: '',
		students: [],
		selectedInstitutions: [],
		selectedQualificationTypes: [],
		selectedDegrees: [],
		selectedYearOfStudy: [],
		selectedInterestedDepartments: [],
		selectedPreferredEmployers: [],
		selectedProgrammes: [],
		selectedRaces: [],
		selectedGenders: [],
		selectedDriversLicenses: [],
		selectedVehicles: [],
		selectedDisabilities: [],
		selectedCitizenships: [],
		selectedCareerTracks: [],
		selectedLocations: [],
		reactiveList: [],
		user: null,
		micros: [],
		currentMicro: null,
		currentJob: null,
		selectedValue: null,
		auth: null,
	}),
	computed: {
		uniqueCareerTracks() {
			return Array.from(new Set(this.currentTalentPoolStudentTalentPool.map(s => s.careerTrack).filter(ct => ct && ct.trim() !== '')));
		},
		studentLength() {
			return this.selected.length;
		},
		uniqueInstitutions() {
			return Array.from(new Set(this.currentTalentPoolStudentTalentPool.map(s => s.qualifications.filter(q => q.institution).map(q => q.institution)).flat()));
		},
		uniqueQualificationTypes() {
			return Array.from(new Set(this.currentTalentPoolStudentTalentPool.map(s => s.qualifications.filter(q => q.graduateStatus).map(q => q.graduateStatus)).flat()));
		},
		uniqueDegrees() {
			return Array.from(new Set(this.currentTalentPoolStudentTalentPool.map(s => s.qualifications.filter(q => q.degree).map(q => q.degree)).flat()));
		},
		uniqueYearOfStudy() {
			return Array.from(new Set(this.currentTalentPoolStudentTalentPool.map(s => s.qualifications.filter(q => q.year !== null).map(q => q.year.toString())).flat()));
		},
		uniqueInterestedDepartments() {
			return Array.from(new Set(this.currentTalentPoolStudentTalentPool.map(s => s.preferredCompanies.department?.map(d => d.department) ?? []).flat()));
		},
		uniquePreferredEmployers() {
			return Array.from(new Set(this.currentTalentPoolStudentTalentPool.map(s => s.preferredCompanies.choices ?? []).flat()));
		},
		uniqueProgrammes() {
			return Array.from(new Set(this.currentTalentPoolStudentTalentPool.map(s => s.programme)));
		},
		uniqueRaces() {
			return Array.from(new Set(this.currentTalentPoolStudentTalentPool.map(s => s.race)));
		},
		uniqueGenders() {
			return Array.from(new Set(this.currentTalentPoolStudentTalentPool.map(s => s.gender)));
		},
		uniqueDriversLicense() {
			return Array.from(new Set(this.currentTalentPoolStudentTalentPool.map(s => s.license)));
		},
		uniqueVehicles() {
			return Array.from(new Set(this.currentTalentPoolStudentTalentPool.map(s => s.vehicle)));
		},
		uniqueDisability() {
			return Array.from(new Set(this.currentTalentPoolStudentTalentPool.map(s => s.disability)));
		},
		uniqueCitizenships() {
			return Array.from(new Set(this.currentTalentPoolStudentTalentPool.map(s => s.citizenship)));
		},
		uniqueLocations() {
			return Array.from(new Set(this.currentTalentPoolStudentTalentPool.map(s => s.location?.town)));
		},
		filteredStudents() {
			const result = this.currentTalentPoolStudentTalentPool.filter(student => {
				const matchesSearch =
					!this.search || student.name.toLowerCase().includes(this.search.toLowerCase()) || student.surname.toLowerCase().includes(this.search.toLowerCase());
				const matchesCareerTracks = this.selectedCareerTracks.length === 0 || (student?.careerTrack && this.selectedCareerTracks.includes(student.careerTrack));

				const matchesInstitutions = this.selectedInstitutions.length === 0 || this.selectedInstitutions.some(i => student.qualifications.some(q => q.institution === i));

				const matchesQualificationTypes =
					this.selectedQualificationTypes.length === 0 || this.selectedQualificationTypes.some(qt => student.qualifications.some(q => q.graduateStatus === qt));

				const matchesDegrees = this.selectedDegrees.length === 0 || this.selectedDegrees.some(d => student.qualifications.some(q => q.degree === d));

				const matchesYearOfStudy =
					this.selectedYearOfStudy.length === 0 || this.selectedYearOfStudy.some(ys => student.qualifications.some(q => q.year !== null && q.year.toString() === ys));

				const matchesInterestedDepartments =
					this.selectedInterestedDepartments.length === 0 ||
					this.selectedInterestedDepartments.some(id => student.preferredCompanies.department?.some(d => d.department === id) ?? false);

				const matchesPreferredEmployers =
					this.selectedPreferredEmployers.length === 0 || this.selectedPreferredEmployers.some(pe => student.preferredCompanies.choices?.includes(pe) ?? false);

				const matchesProgrammes = this.selectedProgrammes.length === 0 || this.selectedProgrammes.includes(student.programme);

				const matchesRaces = this.selectedRaces.length === 0 || this.selectedRaces.includes(student.race);

				const matchesGenders = this.selectedGenders.length === 0 || this.selectedGenders.includes(student.gender);

				const matchesDriversLicenses = this.selectedDriversLicenses.length === 0 || this.selectedDriversLicenses.includes(student.license);

				const matchesVehicles = this.selectedVehicles.length === 0 || this.selectedVehicles.includes(student.vehicle);

				const matchesDisabilities = this.selectedDisabilities.length === 0 || this.selectedDisabilities.includes(student.disability);

				const matchesCitizenships = this.selectedCitizenships.length === 0 || this.selectedCitizenships.includes(student.citizenship);

				const matchesLocations = this.selectedLocations.length === 0 || this.selectedLocations.includes(student.location?.town);

				return (
					matchesSearch &&
					matchesInstitutions &&
					matchesQualificationTypes &&
					matchesYearOfStudy &&
					matchesLocations &&
					matchesCitizenships &&
					matchesDisabilities &&
					matchesVehicles &&
					matchesProgrammes &&
					matchesDriversLicenses &&
					matchesDegrees &&
					matchesGenders &&
					matchesRaces &&
					matchesInterestedDepartments &&
					matchesPreferredEmployers &&
					matchesCareerTracks
				);
			});
			return result;
		},
	},
	watch: {
		filteredStudents(newList) {
			this.reactiveList = newList;
		},
		selectedJob(newJob) {
			this.currentJob = this.jobs.find(element => element.name === newJob);
			this.currentMicro = this.micros.find(element => element.name === newJob);
			this.errorMessage = '';
			this.jobErrorMessage = '';
		},
	},
	methods: {
		promptLogin() {
			this.$router.push({ name: 'Login' });
		},
		closeConfirmationModal() {
			this.emailSent = false;
			window.location.reload();
		},
		async sendJobInvitations() {
			if (!this.selected.length) {
				this.errorMessage = 'Please select at least one student to send an invitation';
				return;
			}
			if (!this.currentJob && !this.currentMicro) {
				this.jobErrorMessage = 'Please select a job';
				return;
			}
			this.loading = true;
			this.openInviteModal = false;

			let slackStudents = [];
			const promises = this.selected.map(async student => {
				const studentName = `${student.name} ${student.surname}`;

				const talentPoolDocRef = doc(db, 'talentPools', this.currentTalentPool.id);
				const talentPoolStudentsSubcollectionRef = collection(talentPoolDocRef, 'talentPoolStudents');
				const studentQuery = query(talentPoolStudentsSubcollectionRef, where('userId', '==', student.userId));
				const studentQuerySnapshot = await getDocs(studentQuery);

				slackStudents.push({ name: studentName, phone: student.phone, email: student.email });

				if (!studentQuerySnapshot.empty) {
					const studentDocSnapshot = studentQuerySnapshot.docs[0];
					const studentDocRef = doc(db, 'talentPools', this.currentTalentPool.id, 'talentPoolStudents', studentDocSnapshot.id);

					const invitationDocRef = doc(collection(studentDocRef, 'invitations'), this.currentJob.jobId);
					await setDoc(
						invitationDocRef,
						{
							status: ApplicationStatus.INVITATIONSENT,
							companyName: this.currentJob.companyName,
							jobName: this.currentJob.name,
							jobId: this.currentJob.jobId,
							studentName: studentName,
							studentEmail: student.email,
							clientId: this.user.userId,
							created: firebase.firestore.Timestamp.now(),
						},
						{ merge: true }
					);
				}

				await this.sendInvitation(this.currentJob.companyName, this.currentJob.jobUrl, studentName, student.email, this.currentJob.name);
			});

			await Promise.all(promises);
			await this.sendBulkSlack(slackStudents, this.currentJob.companyName, this.currentJob.name, this.currentJob.jobUrl, this.currentJob.applicationDeadline);
			this.loading = false;
			this.emailSent = true;
			this.selected = [];
		},
		async sendBulkSlack(students, companyName, jobTitle, jobUrl, applicationDeadline) {
			const sendSlackTalentPoolJobInvite = firebase.functions().httpsCallable('sendSlackTalentPoolJobInvite');

			try {
				const params = {
					students,
					companyName,
					jobTitle,
					jobUrl,
					applicationDeadline,
				};
				await sendSlackTalentPoolJobInvite(params);
			} catch (error) {
				console.log({ error });
			}
		},
		redirectToJobPost() {
			this.$router.push({ name: 'post-a-job' });
		},
		inviteStudent(item) {
			if (!this.auth) {
				this.authError = 'Please log in or sign up to access this feature';
				this.errorAuth = true;
				return;
			}
			this.selected.push(item);
			if (!this.selected.length) {
				this.errorMessage = 'Please select at least one student to send an invitation';
				return;
			}

			this.selected = this.removeDuplicatesByPropertyReduce(this.selected);
			this.openInviteModal = true;
		},
		inviteToInterview() {
			if (!this.auth) {
				this.authError = 'Please log in or sign up to access this feature';
				this.errorAuth = true;
				return;
			}
			if (!this.selected.length) {
				this.errorMessage = 'Please select at least one student to send an invitation';
				return;
			}
			this.errorMessage = '';
			this.openInviteModal = true;
		},
		removeDuplicatesByPropertyReduce(list) {
			return list.reduce((unique, item) => {
				const value = item['userId'];
				const isDuplicate = unique.some(uniqueItem => uniqueItem['userId'] === value);
				return isDuplicate ? unique : [...unique, item];
			}, []);
		},
		clearSelectedList() {
			this.selected = [];
			this.errorMessage = '';
		},
		closeInvitationModal() {
			this.selected = [];
			this.errorMessage = '';
			this.openInviteModal = false;
			this.selectedJob = null;
		},
		onSelect(items) {
			this.selected = items;
		},
		clearFilters() {
			this.selectedInstitutions = [];
			this.selectedQualificationTypes = [];
			this.selectedYearOfStudy = [];
			this.selectedDegrees = [];
			this.selectedInterestedDepartments = [];
			this.selectedPreferredEmployers = [];
			this.selectedProgrammes = [];
			this.selectedRaces = [];
			this.selectedGenders = [];
			this.selectedDriversLicenses = [];
			this.selectedVehicles = [];
			this.selectedDisabilities = [];
			this.selectedCitizenships = [];
			this.selectedLocations = [];
		},
		handleFilterChange(filters) {
			this.selectedInstitutions = filters.institutions || [];
			this.selectedQualificationTypes = filters.qualificationTypes || [];
			this.selectedYearOfStudy = filters.yearOfStudy || [];
			this.selectedDegrees = filters.degrees || [];
			this.selectedInterestedDepartments = filters.interestedDepartments || [];
			this.selectedPreferredEmployers = filters.preferredEmployers || [];
			this.selectedProgrammes = filters.programmes || [];
			this.selectedRaces = filters.races || [];
			this.selectedGenders = filters.genders || [];
			this.selectedDriversLicenses = filters.driversLicense || [];
			this.selectedVehicles = filters.vehicles || [];
			this.selectedDisabilities = filters.disability || [];
			this.selectedCitizenships = filters.citizenships || [];
			this.selectedLocations = filters.locations || [];
			this.selectedCareerTracks = filters.careerTracks || [];
		},
		handleFilterClose() {
			this.isFilterClicked = false;
		},
		toggleFilterMenu() {
			this.isFilterClicked = !this.isFilterClicked;
		},
		async viewStudentinTalentPool(item) {
			this.currentProfile = item;
			this.profileModalVisible = true;
		},
		async getStudentDetails(item) {
			const studentDoc = await db.collection('students').where('userId', '==', item).get();
			if (!studentDoc.empty) {
				const studentData = studentDoc.docs[0].data();
			}
		},
		viewStudentProfile(item) {
			this.profileModalVisible = true;
		},
		profileModalHide() {
			this.profileModalVisible = false;
		},
		setProfileFavourite(item) {
			this.setFavourite(item);
		},
		async setFavourite(item) {
			try {
				const favoriteValue = !item.isTalentPoolFavourite;
				item.isTalentPoolFavourite = favoriteValue;
				const talentPoolDocRef = db.collection('talentPools').doc(this.currentTalentPool.id);
				const talentPoolStudentsSubcollectionRef = talentPoolDocRef.collection('talentPoolStudents');
				const studentQuerySnapshot = await talentPoolStudentsSubcollectionRef.where('userId', '==', item.userId).get();

				if (!studentQuerySnapshot.empty) {
					const studentDocRef = studentQuerySnapshot.docs[0].ref;

					const favouritesSubcollectionRef = studentDocRef.collection('favourites');

					const existingFavouriteDoc = await favouritesSubcollectionRef.where('clientId', '==', this.user.userId).where('studentId', '==', item.userId).limit(1).get();
					if (!existingFavouriteDoc.empty) {
						const existingDocRef = existingFavouriteDoc.docs[0].ref;
						await existingDocRef.update({
							isFavourite: favoriteValue,
						});
					} else {
						await favouritesSubcollectionRef.doc(this.user.userId).set({
							clientId: this.user.userId,
							isFavourite: favoriteValue,
							studentName: item.name,
							studentId: item.userId,
						});
					}
				}
			} catch (error) {
				console.error('Error setting favourite status:', error);
			}
		},
		async loadProfile(alias) {
			const studentDocRef = db.collection('students').doc(alias);
			const usersDocRef = db.collection('users').doc(alias);
			const [studentDoc, usersDoc, qualificationsSnapShot, experiencesSnapShot] = await Promise.all([
				studentDocRef.get(),
				usersDocRef.get(),
				studentDocRef.collection('qualifications').get(),
				studentDocRef.collection('experiences').get(),
			]);

			const student = {
				...studentDoc.data(),
				alias: usersDoc.data().alias,
				name: usersDoc.data().name,
				surname: usersDoc.data().surname,
				email: usersDoc.data().email,
				phone: usersDoc.data().phone,
				qualifications: qualificationsSnapShot.docs.map(doc => doc.data()),
				experiences: experiencesSnapShot.docs.map(doc => doc.data()),
			};
			return student;
		},
		async getStudents(studentList) {
			const profiles = await Promise.all(studentList.map(student => this.loadProfile(student.alias)));
			this.students = profiles;
			return this.students;
		},
		async sendInvitation(companyName, jobUrl, studentName, studentEmail, jobTitle) {
			const sendJobApplicationInvitation = firebase.functions().httpsCallable('sendStudentInvitationToJobApplication');
			try {
				const params = {
					companyName,
					jobUrl,
					studentName,
					studentEmail,
					jobTitle,
				};
				const response = await sendJobApplicationInvitation(params);
				return response;
			} catch (e) {
				console.log({ e });
			}
		},
	},
	async created() {
		this.loading = true;
		this.auth = firebase.auth().currentUser || null;
		const user = firebase.auth().currentUser;
		this.currentTalentPool.id = this.$route.params.id;

		if (this.auth) {
			const userDataQuery = query(collection(db, 'users'), where('userId', '==', user.uid));
			const userDataSnapshot = await getDocs(userDataQuery);
			if (!userDataSnapshot.empty) {
				const userDoc = userDataSnapshot.docs[0].data();
				this.user = userDoc;
				if (this.user.accessType) {
					this.clientId = this.user.clientAlias;
					const originalClientQuery = query(collection(db, 'users'), where('alias', '==', this.clientId));
					const originalClientSnapshot = await getDocs(originalClientQuery);
					if (!originalClientSnapshot.empty) {
						this.user = { ...originalClientSnapshot.docs[0].data() };
					}
					this.invitedClient = true;
				}
			}
			const q = query(collection(db, 'jobs'), where('clientId', '==', this.user.userId));
			const querySnapshot = await getDocs(q);
			querySnapshot.forEach(doc => {
				this.jobs.push(doc.data());
			});
			const micro = query(collection(db, 'micros'), where('clientAlias', '==', this.user.alias));
			const microSnapshot = await getDocs(micro);
			microSnapshot.forEach(doc => {
				const microData = doc.data();
				microData.description = microData.description.replace(/<\/?p>/gi, '').trim();
				this.micros.push(microData);
			});
		}

		try {
			const [talentPoolDoc, studentsSnapshot] = await Promise.all([
				db.collection('talentPools').doc(this.currentTalentPool.id).get(),
				db.collection('talentPools').doc(this.currentTalentPool.id).collection('talentPoolStudents').get(),
			]);

			if (!talentPoolDoc.exists) {
				console.error('Talent pool not found');
				return;
			}

			if (studentsSnapshot.empty) {
				return;
			}

			this.currentTalentPool.name = talentPoolDoc.data().name;
			this.currentTalentPoolStudentTalentPool = await Promise.all(
				studentsSnapshot.docs.map(async doc => {
					const student = doc.data();
					const profile = await this.loadProfile(student.alias);
					let favouritesSnapshot = null;
					let inviteSnapshot = null;
					if (this.auth) {
						favouritesSnapshot = await doc.ref.collection('favourites').where('clientId', '==', this.user.userId).limit(1).get();
						inviteSnapshot = await doc.ref.collection('invitations').where('clientId', '==', this.user.userId).limit(1).get();
					}
					let isTalentPoolFavourite = false;
					if (this.auth && favouritesSnapshot) {
						if (!favouritesSnapshot.empty) {
							const favouriteData = favouritesSnapshot.docs[0].data();
							isTalentPoolFavourite = favouriteData.isFavourite;
						}
					}

					let inviteStatus = 'New';
					if (this.auth && inviteSnapshot) {
						if (!inviteSnapshot.empty) {
							const inviteData = inviteSnapshot.docs[0].data();
							inviteStatus = inviteData.status;
						}
					}

					return {
						...profile,
						isTalentPoolFavourite: isTalentPoolFavourite,
						status: inviteStatus,
					};
				})
			);
		} catch (error) {
			console.error('Error fetching talent pool data:', error);
		}
		this.reactiveList = this.filteredStudents;
		this.loading = false;
	},
};
</script>

<style scoped>
p {
	color: rgb(35, 35, 35);
}
.container {
	margin: 0px 20px;
}
.talentPool {
	display: flex;
	flex-direction: column;
}
.talentPoolActions {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin-top: 20px;
}
.md-table {
	width: 100% !important;
	table-layout: fixed !important;
	overflow-x: auto !important;
}
.md-table >>> .md-table-head {
	background-color: #ff5722 !important;
}
.md-table >>> .md-table-head-label {
	color: rgb(255, 255, 255) !important;
}
.modal-container {
	z-index: 3;
}
.info-pill {
	display: inline-block;
	padding: 4px 12px;
	margin: 4px;
	border: 1px solid #ccc;
	border-radius: 999px;
	background-color: #fff;
	color: #333;
	font-size: 0.9em;
	white-space: nowrap;
	vertical-align: middle;
}
.jobDetails {
	border: 1px solid grey;
	background-color: rgb(251, 249, 249);
	border-radius: 8px;
	margin-top: 20px;
	margin-bottom: 20px;
	padding-bottom: 15px;
}
.modal-testing {
	display: flex;
	align-items: center;
	justify-content: center;
	border-top-left-radius: 0.3rem;
	border-top-right-radius: 0.3rem;
	border: 1px solid pink;
}
.background {
	width: 100vw !important;
	height: 100vh !important;
	display: flex !important;
	align-items: center !important;
	justify-content: center !important;
}
.talent-pool-container {
	width: inherit;
}
</style>
